/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Donatekey_Successdesc2Inputs */

const id_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima kasih atas donasi Anda! Item telah ditukarkan dengan benar dan datanya akan segera tersedia.`)
};

const ms_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima kasih atas dermaan anda! Item telah ditebus dengan betul dan datanya akan tersedia tidak lama lagi.`)
};

const da_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak for din donation! Varen er blevet indløst korrekt og dens data vil være tilgængelig snart.`)
};

const de_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielen Dank für Ihre Spende! Der Gegenstand wurde erfolgreich eingelöst und seine Daten werden bald verfügbar sein.`)
};

const en_us2_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your donation! The item has been redeemed correctly and it's data will be available soon.`)
};

const es_es2_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias por tu donación! El item se ha canjeado correctamente y sus datos estarán disponibles pronto.`)
};

const es_mx2_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias por tu donación! El ítem se ha canjeado correctamente y sus datos estarán disponibles pronto.`)
};

const fil_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salamat sa iyong donasyon! Ang item ay na-redeem nang tama at ang data nito ay magiging available sa lalong madaling panahon.`)
};

const fr_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci pour votre don ! L'item a été échangé correctement et ses données seront bientôt disponibles.`)
};

const it_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie per la tua donazione! L'articolo è stato riscattato correttamente e i suoi dati saranno presto disponibili.`)
};

const hu_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Köszönjük az adományod! Az elem sikeresen beváltásra került, és az adatai hamarosan elérhetőek lesznek.`)
};

const nl_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedankt voor je donatie! Het item is correct ingewisseld en de gegevens zullen binnenkort beschikbaar zijn.`)
};

const no_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takk for donasjonen! Elementet er innløst og dataene vil være tilgjengelige snart.`)
};

const pl_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziękujemy za darowiznę! Element został pomyślnie aktywowany, a jego dane będą wkrótce dostępne.`)
};

const pt_br2_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your donation! The item has been redeemed correctly and it's data will be available soon.`)
};

const pt_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado pela sua doação! O item foi resgatado corretamente e os seus dados estarão disponíveis em breve.`)
};

const ro_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulțumim pentru donație! Elementul a fost răscumpărat corect și datele sale vor fi disponibile în curând.`)
};

const fi_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiitos lahjoituksestasi! Kohde on lunastettu oikein ja sen tiedot ovat saatavilla pian.`)
};

const sv_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tack för din donation! Objektet har lösts in korrekt och dess data kommer snart att finnas tillgänglig.`)
};

const vi_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảm ơn bạn đã quyên góp! Mục đã được đổi thành công và dữ liệu của nó sẽ sớm có sẵn.`)
};

const tr_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağışınız için teşekkürler! Öğe başarıyla kullanıldı ve verileri yakında kullanılabilir olacak.`)
};

const cs_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Děkujeme za váš dar! Položka byla úspěšně uplatněna a její data budou brzy k dispozici.`)
};

const bg_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Благодарим ви за вашето дарение! Обектът беше осребрен успешно и данните му ще бъдат налични скоро.`)
};

const ru_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спасибо за ваше пожертвование! Объект был успешно активирован, и его данные скоро будут доступны.`)
};

const uk_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дякуємо за вашу пожертву! Елемент успішно активовано, його дані будуть доступні незабаром.`)
};

const ar_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شكرًا لك على تبرعك! تم استلام العنصر بنجاح وستكون بياناته متاحة قريبًا.`)
};

const hi_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दान के लिए धन्यवाद!`)
};

const th_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขอบคุณสำหรับการบริจาค! รายการได้รับการรับเรียบร้อยแล้วและข้อมูลจะพร้อมใช้งานเร็ว ๆ นี้`)
};

const ja_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄付ありがとうございます！アイテムは正常に引き換えられ、データはまもなく利用可能になります。`)
};

const zh_cn2_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your donation! The item has been redeemed correctly and it's data will be available soon.`)
};

const zh_hant1_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your donation! The item has been redeemed correctly and it's data will be available soon.`)
};

const ko_forms_donatekey_successdesc2 = /** @type {(inputs: Forms_Donatekey_Successdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your donation! The item has been redeemed correctly and it's data will be available soon.`)
};

/**
* | output |
* | --- |
* | "Thank you for your donation! The item has been redeemed correctly and it's data will be available soon." |
*
* @param {Forms_Donatekey_Successdesc2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_donatekey_successdesc2 = /** @type {((inputs?: Forms_Donatekey_Successdesc2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Donatekey_Successdesc2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_donatekey_successdesc2(inputs)
	if (locale === "ms") return ms_forms_donatekey_successdesc2(inputs)
	if (locale === "da") return da_forms_donatekey_successdesc2(inputs)
	if (locale === "de") return de_forms_donatekey_successdesc2(inputs)
	if (locale === "en-US") return en_us2_forms_donatekey_successdesc2(inputs)
	if (locale === "es-ES") return es_es2_forms_donatekey_successdesc2(inputs)
	if (locale === "es-MX") return es_mx2_forms_donatekey_successdesc2(inputs)
	if (locale === "fil") return fil_forms_donatekey_successdesc2(inputs)
	if (locale === "fr") return fr_forms_donatekey_successdesc2(inputs)
	if (locale === "it") return it_forms_donatekey_successdesc2(inputs)
	if (locale === "hu") return hu_forms_donatekey_successdesc2(inputs)
	if (locale === "nl") return nl_forms_donatekey_successdesc2(inputs)
	if (locale === "no") return no_forms_donatekey_successdesc2(inputs)
	if (locale === "pl") return pl_forms_donatekey_successdesc2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_donatekey_successdesc2(inputs)
	if (locale === "pt") return pt_forms_donatekey_successdesc2(inputs)
	if (locale === "ro") return ro_forms_donatekey_successdesc2(inputs)
	if (locale === "fi") return fi_forms_donatekey_successdesc2(inputs)
	if (locale === "sv") return sv_forms_donatekey_successdesc2(inputs)
	if (locale === "vi") return vi_forms_donatekey_successdesc2(inputs)
	if (locale === "tr") return tr_forms_donatekey_successdesc2(inputs)
	if (locale === "cs") return cs_forms_donatekey_successdesc2(inputs)
	if (locale === "bg") return bg_forms_donatekey_successdesc2(inputs)
	if (locale === "ru") return ru_forms_donatekey_successdesc2(inputs)
	if (locale === "uk") return uk_forms_donatekey_successdesc2(inputs)
	if (locale === "ar") return ar_forms_donatekey_successdesc2(inputs)
	if (locale === "hi") return hi_forms_donatekey_successdesc2(inputs)
	if (locale === "th") return th_forms_donatekey_successdesc2(inputs)
	if (locale === "ja") return ja_forms_donatekey_successdesc2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_donatekey_successdesc2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_donatekey_successdesc2(inputs)
	return ko_forms_donatekey_successdesc2(inputs)
});
export { forms_donatekey_successdesc2 as "forms.donateKey.successDesc" }